"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.imgGen.name': 'Generazione Immagini',
    'tools.imgGen.description': 'Genera immagini da descrizioni testuali',
};
